<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="addColumns"
    ></page-template>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';

export default {
  components: {
    pageTemplate

  },
  data() {
    return {
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {label: "类型名称", prop: "name", type: "input", isFuzzy: true, placeholder: "请输入类型名称"},
          {label: "类型编码", prop: "code", type: "input", isFuzzy: true, placeholder: "请输入类型编码"},
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert',
        },
        {
          label: '编辑',
          type: this.$utils.buttonType.tableOperate,
          code: 'update',
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate,
        },
      ],
      // 表格信息配置
      tableOptions: {
        columns: [
          {label: '序号', prop: 'id', width: '80', align: 'center'},
          {label: '设备类型名称', prop: 'name', width: '120', align: 'center'},
          {label: '设备类型编码', prop: 'code', width: '120', align: 'center'},
          {label: '创建人', prop: 'createBy', width: '120', align: 'center'},
          {label: '创建时间', prop: 'createDttm', width: '120', align: 'center'},
          {label: '修改人', prop: 'lastModifyBy', width: '120', align: 'center'},
          {label: '修改时间', prop: 'lastModifyDttm', width: '120', align: 'center'},
          {label: '备注', prop: 'remarks', width: '120', align: 'center'},
        ],
        url: api.store.deviceCategory
      },
      // 添加字段
      addColumns: {
        labelWidth: '120px',
        span: 12,
        columns: [
          {
            label: '设备类型',
            type: 'select',
            prop: 'type',
            data: this.$utils.getCacheStatus('seDeviceCategory.type'),
            placeholder: "请选择设备类型",
            rule: [
              {required: true, message: '请选择设备类型', trigger: 'blur'},
            ],
          },
          {
            label: '设备类型名称',
            type: 'input',
            prop: 'name',
            placeholder: "请输设备类型名称",
            rule: [
              {required: true, message: '请输设备类型名称', trigger: 'blur'},
            ],
          },
          {
            label: '设备类型编码',
            type: 'input',
            prop: 'code',
            placeholder: "请输入设备类型编码",
            rule: [
              {required: true, message: '请输入设备类型编码', trigger: 'blur'},
            ],
          },
          {
            label: '备注',
            type: 'textarea',
            span: 22,
            prop: 'remarks'
          },

        ], // 表单label
        url: api.store.deviceCategory
      },
    };
  },
  created() {
  },
  methods: {}
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/store/device/Category.vue